import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';

class SetCustomDataCapture extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                    ImageInformation Web Service
                    </h1>
                    <div>
                    <h2 className="main-subheading">
                            SetCustomDataCapture</h2>
                    <div className="technical-main-content">
                        <p>
                            The SetCustomDataCapture method is typically used by the Service Aggregator to define
                            various elements to be captured and associated with each new card design. The data
                            elements can then be used to retrieve the designs instead of relying on the standard
                            CardImageId. If the card design is Denied, the Service Aggregator should trigger
                            the appropriate business procedure to deal with such cases (for example, issue the
                            Cardholder with a standard plastic).</p>
                        <div>
                            <h3>
                                WSDL URL</h3>
                            <p>
                                Thales will provide the WSDL URL for DevServer during the project.</p>
                            <br />
                        </div>
                        <div>
                            <h3>
                                Request Parameters</h3>
                            <ul>
                                <li><b>CardImageID</b> (string)
                                    <p>
                                    The unique identifier for the image being requested, This is generated by the Designer
                                    Website and passed to the Subscriber during the Handback procedure.</p> </li>
                                <li><b>ImageInformation_Key</b> (GUID string)
                                    <p>
                                    This value identifies the caller and is matched to the Service Aggregator. This
                                    guarantees that the caller should have access to the requested CardImageID. Thales
                                    will provide the Aggregator with the value for this parameter. Also note that a
                                    different value will be used on each environment (see the Handover URL section for
                                    an explanation of the environments).</p> </li>
                                <li><b>DataCapture</b> (string)
                                    <p>
                                    This identifies the various data elements captured and associated with a card design.
                                    <br />
                                    <br />
                                    &nbsp;&nbsp;&nbsp;<b>Format:</b> &lt;CataCaptureName&gt;=&lt;DataCaptureValue&gt;&amp;&lt;CataCaptureName&gt;=&lt;DataCaptureValue&gt;
                                    <br />
                                    <br />
                                    &nbsp;&nbsp;&nbsp;<b>Example:</b> Name=John Smith&Mobile=12345678910 </p></li>
                            </ul>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Response Paramters</h3>
                            <ul>
                                <li><b>SetCustomDataCaptureResult</b> (integer)
                                    <p>
                                    This indicates the result of elements captured and associated with a card design.</p>
                                </li>
                            </ul>
                            <br/>
                        </div>
                        <div>
                            <h3>
                                Set Custom Data Capture Result</h3>
                            <ul>
                                <li><b>-2 (Unexpected system error)</b>: An internal error occurred. This indicates that the caller is not allowed to make a request due to IP transparency check.</li>
                                <li><b>-1 (Unexpected system error)</b>: An internal error occurred. The caller should
                                    attempt to call the method again. If a high number of such errors are encountered,
                                    the problem should be escalated to manual operators at Thales.</li>
                                <li><b>0 (Success)</b>: The method call was successful.</li>
                                <li><b>1 (CardImageID is invalid)</b>: The CardImageID isn’t a valid identifier.</li>
                                <li><b>2 (ImageInformation_Key is invalid or doesn’t match CardImageId)</b>: The CardImageID
                                    and ImageInformation_Key do not match. This error will usually occur when an invalid
                                    or incorrect ImageInformation_Key is used.</li>
                                <li><b>3 (DataCaptureFieldsDoNotMatch)</b>: The data capture field keys passed in and
                                    the field keys in the database do not match. </li>
                                <li><b>4 (CardImageIdDidNotReturnClient)</b>: Retrieving Client details with CardImageId
                                    failed.</li>
                                <li><b>5 (DataCaptureFieldsNotSetForUpdate)</b>: Specified data capture field keys passed
                                    in do not match card design data capture fields.</li>
                                <li><b>6 (DataCaptureNotInformed)</b>: Data Capture field was not informed.</li>
                            </ul>
                            <br/>
                        </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/imageinformation'>Back</Link>
                        </div>
                    </div>
                    </div>
                    </div>
        )
    }
}

export default SetCustomDataCapture;